module.exports = __webpack_public_path__ + "files/4f7de5e8df3072a0596eb15b52b18c09.woff2";


/*****************
 ** WEBPACK FOOTER
 ** ./non_npm_dependencies/google-fonts/fonts/Lora-regular.woff2
 ** module id = 863
 ** module chunks = 0
 **/